<template>
  <div class="gam-modal">
    <modal
      :active="true"
      size="small"
      :delete-button-label="
        typeof gamDetails === 'object' && gamDetails ? 'Navigate to Gam' : ''
      "
      :close-on-click-outside="true"
      tertiary-button-label="Close"
      :primary-button-label="gamDetails === 'not-found' ? 'Create GAM' : ''"
      @onDelete="onNavigateGamClick"
      @onConfirm="onNavigateGamCreateClick()"
      @onClose="onClose()">
      <template #header>
        <p>Gam Details</p>
      </template>
      <template #content>
        <div class="gam-modal__body">
          <div
            v-if="gamDetails === 'not-found' && !disputeModalLoading"
            class="gam-modal__body__create-gam">
            Active GAM details not found for invoice no {{ invoiceNumber }}. You
            can proceed to create GAM for the same.
          </div>
          <div
            v-else-if="gamDetails && !disputeModalLoading"
            class="gam-modal__body__show-gam">
            <div
              v-for="item in gamStatusInformationConstant"
              :key="item.label"
              class="gam-modal__body__show-gam__item">
              <span class="gam-modal__body__show-gam__item__title">
                {{ item.label }}:
              </span>
              <div class="gam-modal__body__show-gam__item__value">
                <div
                  v-if="item.slotKey === 'waiverAmount'"
                  class="gam-modal__body__show-gam__item__value__amount">
                  <div
                    v-for="waiverAmount in gamDetails[item.slotKey]"
                    :key="waiverAmount">
                    <span>{{ waiverAmount }}</span>
                  </div>
                </div>
                <div v-else>
                  {{ gamDetails[item.slotKey] }}
                </div>
              </div>
            </div>
          </div>
          <loading
            v-else
            :active.sync="loader"
            :can-cancel="false"
            :is-full-page="true"
            color="#0573ab" />
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
// Constants
import { REDIRECT_GAM_URI } from "@/config/constant.js";
import { gamStatusInformationConstant } from "@/config/disputeDataConstant.js";
import { isEmpty } from "@/utils/helpers.js";
import Loading from "vue-loading-overlay";
export default {
  name: "ShowGamDetailsModal",
  components: {
    Loading,
  },
  props: {
    gamDetails: {
      type: Object,
      default() {
        return {};
      },
    },
    invoiceNumber: {
      type: String,
      require: false,
    },
    disputeModalLoading: {
      type: Boolean,
      require: true,
    },
  },
  data() {
    return {
      gamStatusInformationConstant,
    };
  },
  computed: {
    loader() {
      return this.disputeModalLoading;
    },
  },
  methods: {
    isEmpty,

    onClose() {
      this.$emit("onModalClose");
    },
    onNavigateGamClick() {
      this.$emit("onModalClose");
      window.open(
        `${REDIRECT_GAM_URI}gam-ticket/${this.gamDetails.gam_id}?type=${
          this.gamDetails.is_bulk ? "bulk" : "single"
        }`,
        "_blank"
      );
    },
    onNavigateGamCreateClick() {
      this.$emit("onModalClose");
      window.open(REDIRECT_GAM_URI, "_blank");
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/imports";

.gam-modal {
  .modal--small {
    height: 350px;
    width: 500px;
  }
  .modal__header__close {
    display: none;
  }
  .modal__footer__buttons__left--underline {
    color: #0000ff;
  }
  &__body {
    &__create-gam {
      margin-top: 10px;
      font-family: "Maersk Headline";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: var(--Gray-700);
    }
    &__show-gam {
      display: flex;
      flex-direction: column;
      &__item {
        margin-top: 10px;
        display: flex;
        flex-direction: row;
        &__title {
          color: var(--Gray-600);
          flex-basis: 100%;
          flex: 1.3;
        }
        &--colon {
          flex-basis: 100%;
          flex: 0.04;
        }
        &__value {
          flex-basis: 100%;
          flex: 2;
          &__amount {
            display: grid;
            grid-template-columns: 1fr 1fr;
          }
        }
      }
    }
  }
}
</style>
